// extracted by css-extract-rspack-plugin
export default {"gif":"gif-FMdGdA","withDark":"withDark-e3BwIE","gifDark":"gifDark-qY_mi_"};